export async function openDocument(id, data, mimeType) {
    const arrayBuffer = await data.arrayBuffer();

    const blob = new Blob([arrayBuffer], {type: mimeType});
    const blobUrl = URL.createObjectURL(blob);

    const frame = document.getElementById(id);
    if (frame) {
        frame.onload = () => URL.revokeObjectURL(blobUrl);
        frame.src = blobUrl;
    }
}

export function openDocumentFromUrl(id, blobUrl) {
    const frame = document.getElementById(id);
    if (frame) {
        frame.onload = () => URL.revokeObjectURL(blobUrl);
        frame.src = blobUrl;
    }
}
